import LogoDiadWhite from "../../assets/logodiadunjbgwhite.png";
import { Dropdown, Menu, message } from "antd";
import { MenuOutlined, UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { logout } from "../../api/auth";
import * as SHARED from "../../utils/shared";

const handleLogout = () => {
  message.info("¡Hasta luego!");
  logout();
  window.location.reload();
};

const menu = (
  <Menu onClick={handleLogout}>
    <Menu.Item key="1" icon={<LogoutOutlined />}>
      Cerrar sesión
    </Menu.Item>
  </Menu>
);

function HeaderAdmin(props) {
  const { usuario, showDrawer } = props;

  return (
    <header
      className="flex items-center justify-between w-full h-16 px-6"
      style={{ background: "#D41D3D" }}
    >
      <div className="flex items-center gap-4">
        <button onClick={showDrawer} className="md:hidden">
          <MenuOutlined className="text-white" />
        </button>
        <img src={LogoDiadWhite} width={150} alt="Logo DIAD-UNJBG" />
      </div>
      <h1 className="hidden md:block text-white font-semibold text-base">
        {SHARED.NOMBRE_SISTEMA + " " + SHARED.PROCESO}
      </h1>
      <div className="flex items-center">
        <Dropdown.Button overlay={menu} placement="bottomLeft" icon={<UserOutlined />}>
          {usuario.usuario || "Usuario"}
        </Dropdown.Button>
      </div>
    </header>
  );
}

export default HeaderAdmin;
